import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import InviteFriendBox from '../InviteFriendBox'
import useQueryGetInviteFriend from '@/modules/promotion/api/hooks/useQueryGetInviteFriend'
import Spinner from '@/common/components/Spinner'

export default function InviteFriendListing() {
	const { data: defaultValue, isLoading } = useQueryGetInviteFriend()

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`ตั้งค่าการชวนเพื่อน`}
					description="ส่วนแบ่งเครดิตจากยอดเทิร์นจะคิดเมื่อเพื่อนเล่นแบบไม่ฝากโปร"
				/>
			</div>
			<Separator />
			{isLoading ? (
				<Spinner />
			) : (
				<InviteFriendBox defaultValue={defaultValue} isLoading={isLoading} />
			)}
		</div>
	)
}
